import React from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import DashboardMainTitle from '../../dashboardTitle/DashboardMainTitle'
import DashboardContent from '../../dashboardWrapper/DashboardContent'
import Wrapper from '../../dashboardWrapper/Wrapper'
import Ads from './ads/Ads'
import Announcements from './announcements/Announcements'
import Contact from './contact/Contact'
import Ethics from './ethics/Ethics'
import FooterLinks from './footerLinks/FooterLinks'
import Gallery from './gallery/Gallery'
import News from './news/News'
import PrivacyPolicy from './privacy/PrivacyPolicy'
import './style.scss'

const DashboardSiteManagement = () => {
    const {t} = useTranslation();
    let userdata = JSON.parse(localStorage.getItem("user"))

    return (
        <Wrapper>
            <DashboardContent>  
                <DashboardMainTitle> {t("dashboard_nav_home_page_management")} </DashboardMainTitle>

                <Tabs defaultActiveKey="news" className='site_manage_tabs'>
                    <Tab eventKey="news" title={t("news")} className='dashboard_tab'>
                        <News />
                    </Tab>
                    <Tab eventKey="notifications" title={t("announcements")} className='dashboard_tab'>
                        <Announcements />
                    </Tab>
                    <Tab eventKey="gallery" title={t("pictures gallery")} className='dashboard_tab'>
                        <Gallery />
                    </Tab>
                    <Tab eventKey="contact" title={t("contact us")} className='dashboard_tab'>
                        <Contact />
                    </Tab>
                    <Tab eventKey="footerLinks" title={t("links")} className='dashboard_tab'>
                        <FooterLinks />
                    </Tab>
                    <Tab eventKey="privacy" title={t("privacy")} className='dashboard_tab'>
                        <PrivacyPolicy />
                    </Tab>
                    <Tab eventKey="ethics" title={t("ethics")} className='dashboard_tab'>
                        <Ethics />
                    </Tab>
                    {userdata && userdata.role === "DEVELOPER" ?
                        <Tab eventKey="ads" title={t("advertising")} className='dashboard_tab'>
                            <Ads />
                        </Tab>
                    :
                        ''
                    }
                    
                </Tabs>
            </DashboardContent>
        </Wrapper>
    )
}

export default DashboardSiteManagement
